module.exports = __webpack_public_path__ + "static/media/fake-notification-icon-2.38cbc6cb.svg";